<form class="form-inline inline-flex">
  <label class="my-1 mr-2 text-pagination-limit" for="showing-page">{{'PAGINATION.Show' | translate}}</label>
  <select [(ngModel)]="pageSizeConfig" (ngModelChange)="paginationOnChangeSize($event)"
    [ngModelOptions]="{standalone: true}" class="form-control-sm my-1 mr-2 force-bg-light">
    <option selected value="10">10</option>
    <option value="25">25</option>
    <option value="50">50</option>
    <option value="100">100</option>b
  </select>
  <p class="text-pagination-limit">{{'PAGINATION.entries' | translate}}</p>
</form>
